import React from "react";
import logo from "../assets/img/state-govt-logo.png";
import "./AuthSplitLayout.css";

export default function AuthSplitLayout({ children }) {
  const year = new Date().getFullYear();

  return (
    <main className="auth-split">
      <aside className="auth-brand">
        <span className="auth-brand-glow" aria-hidden="true" />
        <img
          src={logo}
          alt=""
          aria-hidden="true"
          className="auth-brand-watermark"
        />

        <div className="auth-brand-inner">
          <p className="auth-brand-eyebrow">
            <span className="auth-brand-flag" aria-hidden="true" />
            Katsina State Government
          </p>

          <div className="auth-brand-head">
            <img
              src={logo}
              alt="Katsina State Government seal"
              className="auth-brand-logo"
            />
            <div className="auth-brand-names">
              <p className="auth-brand-title">KIFMIS</p>
              <p className="auth-brand-name">
                Katsina State Integrated Financial Management Information System
              </p>
            </div>
          </div>

          {/* <p className="auth-brand-tagline">
            One trusted record for every naira released, received and reported.
          </p>

          <ul className="auth-brand-points">
            <li>Treasury, MDA and budget operations in one system</li>
            <li>An audited trail on every release and payment</li>
            <li>Role-based access for every officer</li>
          </ul> */}
        </div>

        <p className="auth-brand-footer">
          Home of Heritage &amp; Hospitality
          <span className="auth-brand-version">v2.0</span>
        </p>
      </aside>

      <div className="auth-form-panel">
        <img
          src={logo}
          alt=""
          aria-hidden="true"
          className="auth-panel-watermark"
        />
        <div className="auth-card">{children}</div>
        <p className="auth-form-footnote">
          © {year} Katsina State Government · KIFMIS
        </p>
      </div>
    </main>
  );
}
